module.exports = __webpack_public_path__ + "static/media/secure-login.14c15af9.svg";